export default "__VITE_ASSET__db2fd447__$_#icon-arrow__"